import {SelectionListener} from "../types";

export class SelectionManager {

    private listeners: SelectionListener[] = [];

    addListener = (listener: SelectionListener) => {
        if (this.listeners.indexOf(listener) === -1) {
            this.listeners.push(listener);
            return true;
        }
        return false;
    };

    getCount() {
        return this.listeners.length;
    }

    removeListener = (listener: SelectionListener) => {
        const index = this.listeners.indexOf(listener);
        if (index !== -1) {
            const result = this.listeners.splice(index, 1);
            return !!result;
        }
        return false;
    };

    informListeners(selection: any) {
        [...this.listeners].forEach((listener) => {
            try {
                listener.onSelect(selection);
            } catch (err) {
                console.error(err);
            }
        });
    }

    clear() {
        this.listeners = [];
    }

}